export default __webpack_public_path__ + "static/media/icon_service_m.383445dc.svg";